module.exports = __webpack_public_path__ + "static/img/0016.ea93dcfa.png";